import { css, createGlobalStyle } from 'styled-components';

/**
 * These bokeh styles were brought over from the Navigation repo.
 *
 * Although not ideal, these changes will get us to the Bokeh rebrand faster,
 * and in the background we will refactor/migrate the top nav components to use Bokeh.
 */
export const UserProfileMenuBokehStyles = createGlobalStyle<{
  isBokeh: boolean;
  theme: { name: string };
}>`
  ${(props) =>
    props.isBokeh &&
    css`
      #teamInfo,
      #profile_dropdown .invite-members-button {
        align-items: center;
        padding-block: 0px;
        padding-inline: 16px;
        border-radius: 12px;
        border: unset;
        color: ${props.theme?.name === 'light'
          ? 'var(--vimeo-colors-gray-900)'
          : 'var(--vimeo-colors-gray-50)'};
        background: ${props.theme?.name === 'light'
          ? 'var(--vimeo-colors-darkBlueAlpha-200)'
          : 'var(--vimeo-colors-lightBlueAlpha-300)'};

        &:hover {
          background: ${props.theme?.name === 'light'
            ? 'var(--vimeo-colors-darkBlueAlpha-300)'
            : 'var(--vimeo-colors-lightBlueAlpha-400)'};
        }
      }

      #profile_dropdown .team-switcher-loading-container {
        --input-font-size: var(--vimeo-fontSizes-input-md);
        --input-height: var(--vimeo-sizes-md);
        --input-border-radius: var(--vimeo-radii-input-md);
        --input-padding: var(--vimeo-space-input-md);
        height: var(--input-height);
        font-size: var(--input-font-size);
        border: 1px solid var(--vimeo-colors-input-stroke);
        border-radius: var(--input-border-radius);
        color: var(--vimeo-colors-text-primary);
        background-color: var(--vimeo-colors-surface);
        transition: 120ms ease-in-out;
        width: 100%;
        box-shadow: rgb(0, 173, 239) 0px 0px 0px 0px;

        & .team-switcher-loader {
          background: ${(props) =>
            props.theme.name === 'light'
              ? 'linear-gradient(290deg, var(--vimeo-colors-gray-100) 10%, var(--vimeo-colors-gray-200) 50%, var(--vimeo-colors-gray-100) 90%)'
              : 'linear-gradient(290deg, var(--vimeo-colors-gray-800) 10%, var(--vimeo-colors-gray-700) 50%, var(--vimeo-colors-gray-800) 90%)'};
        }
      }

      #profileLogo {
        height: 24px !important;
        width: 24px;
      }

      /** Menu content styles */
      #profile_dropdown,
      .user-submenu,
      .team-switcher-popover {
        border: unset;
        outline: transparent solid 2px;
        outline-offset: 2px;
        max-height: fit-content;
        backdrop-filter: blur(var(--vimeo-blur-lg));
        z-index: var(--vimeo-zIndices-dropdown);
        border-radius: var(--vimeo-radii-md);
        box-shadow: var(
          --vimeo-shadows-md,
          0px 0px 24px -5px rgba(0, 0, 0, 0.16),
          0px 0px 4px 0px rgba(0, 0, 0, 0.08)
        );
        padding: var(--vimeo-space-2);
        background: ${(props) =>
          props.theme?.name === 'dark'
            ? 'var(--vimeo-colors-gray-700)'
            : 'var(--vimeo-colors-gray-50)'};
      }

      .team-switcher-popover {
        background: ${(props) =>
          props.theme?.name === 'dark'
            ? 'var(--vimeo-colors-gray-800)'
            : 'var(--vimeo-colors-gray-50)'};
      }

      /** Menu item default styles */
      #profile_dropdown li a,
      .user-submenu li a,
      .team-switcher-item {
        text-decoration: none;
        color: var(--vimeo-colors-text-primary);
        user-select: none;
        display: flex;
        width: 100%;
        align-items: center;
        text-align: start;
        flex: 0 0 auto;
        outline: transparent solid 2px;
        outline-offset: 2px;
        background: transparent;
        padding: var(--vimeo-space-2);
        cursor: pointer;
        font-size: var(--vimeo-fontSizes-body-md);
        font-weight: normal;
        border-radius: var(--vimeo-radii-sm);
      }

      /** Menu item hover styles */
      #profile_dropdown li:hover,
      .team-switcher-item:hover {
        background: ${(props) =>
          props.theme?.name === 'dark'
            ? 'var(--vimeo-colors-lightBlueAlpha-300)'
            : 'var(--vimeo-colors-darkBlueAlpha-200)'};
        color: ${(props) =>
          props.theme?.name === 'dark' ? 'white' : 'var(--vimeo-colors-gray-900)'};
      }

      /** Menu item selected styles */
      #profile_dropdown .list-item-selected li,
      #profile_dropdown .user-profile-link:hover {
        background: ${(props) =>
          props.theme?.name === 'dark'
            ? 'var(--vimeo-colors-lightBlueAlpha-300)'
            : 'var(--vimeo-colors-darkBlueAlpha-200)'};
      }

      /** Select styles */
      #profile_dropdown .team-switcher-dropdown {
        height: var(--input-height);
        font-size: var(--input-font-size);
        padding-block: 0px;
        border: 1px solid var(--vimeo-colors-input-stroke);
        border-radius: var(--input-border-radius);
        color: var(--vimeo-colors-text-primary);
        background-color: var(--vimeo-colors-surface);
        transition: 120ms ease-in-out;
        width: 100%;
        margin: 0px;
        overflow: visible;
        line-height: 1.5;
        overflow-wrap: break-word;
        box-shadow: rgb(0, 173, 239) 0px 0px 0px 0px;
        cursor: pointer;
        appearance: none;
        --input-font-size: var(--vimeo-fontSizes-input-md);
        --input-height: var(--vimeo-sizes-md);
        --input-border-radius: var(--vimeo-radii-input-md);
        --input-padding: var(--vimeo-space-input-md);
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          align-items: center;
        }
      }

      /** Tooltip styles */
      #profile_dropdown .tooltip-body {
        border: unset;
        font-size: var(--vimeo-fontSizes-body-md);
        background-color: ${props.theme?.name === 'dark'
          ? 'var(--vimeo-colors-gray-600)'
          : 'var(--vimeo-colors-gray-200)'};
        text-align: center;
        border-radius: var(--vimeo-radii-sm);
        padding-block: var(--vimeo-space-1);
        padding-inline: var(--vimeo-space-3);
        color: var(--vimeo-colors-text-primary);
        z-index: var(--vimeo-zIndices-tooltip);
        backdrop-filter: blur(var(--vimeo-blur-md));
      }

      /** Center the two paragraph elements */
      #profile_dropdown .tooltip-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    `}
`;
